import type { RouteLocationRaw } from 'vue-router'
import { router } from '@/router'
import type { createApp } from 'vue'
import D from 'dayjs'
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { ComponentCustomProperties } from 'vue'
import { isNumber, isString } from '@bd/vue3-utils'
const tools = {
  // 在新窗口打开路由
  openNewTab(to: RouteLocationRaw) {
    const { href } = router.resolve(to)
    window.open(href, '_blank')
  },
  safeGo(name, type: 'push' | 'replace' = 'push', args?: Record<string, any>, isBlank = false) {
    const routeParams = { name, ...args }
    if (router.hasRoute(name)) {
      if (isBlank) {
        const { href } = router.resolve(routeParams)
        window.open(href, '_blank')
      } else {
        router[type](routeParams)
      }
    }
  },
  safeBack(name?: string) {
    if (!name) {
      router.back()
      return
    }
    if (!router.hasRoute(name)) {
      router.push('/')
      return
    }
    if (window.history?.state?.back === name) {
      router.back()
      return
    }
    router.replace({ name })
  },
  timeFormat(time: unknown, tpl = 'YYYY-MM-DD HH:mm:ss') {
    if (isNumber(time) || isString(time)) {
      return D(time).format(tpl)
    }
    return ''
  },
  unixFormat(time: unknown, tpl = 'YYYY-MM-DD HH:mm:ss') {
    if (isNumber(time)) {
      return D.unix(time).format(tpl)
    }
    return ''
  }
}

export default (app: ReturnType<typeof createApp>) => {
  app.config.globalProperties.$tools = tools
}

export const useTools = () => {
  return tools
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $tools: typeof tools
  }
}
